module.exports = __webpack_public_path__ + "static/media/dashboard_banner.d04f4df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard_banner.png
// module id = 1527
// module chunks = 0